// extracted by mini-css-extract-plugin
module.exports = {"button":"Login_button__3Ul1n","text-primary":"Login_text-primary__2wVrh","text-danger":"Login_text-danger__1I7XJ","card":"Login_card__vJgxM"};